import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { actionCreators } from '../../store'
import styles from './index.module.css'


class CollectItemInput extends Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
    }

    componentDidMount() {
        this.inputRef.current && this.inputRef.current.focus()
    }

    render() {
        return (
            <>
                <input
                    className={styles.input}
                    type="text"
                    value={this.props.ConversationNameEdit}
                    onChange={(event) => { this.handleConversationNameChange(event, this.props.CurrentConversationId) }}
                    onBlur={() => { this.handleConversationNameBlur(this.props.CurrentConversationId) }}
                    ref={this.inputRef}
                />
            </>
        )
    }

    handleConversationNameChange(event, conversation_id) {
        let value = event.target.value
        let data = this.props.collection_conversation_list.toJS()
        for (let item of data) {
            if (item.conversation_id === conversation_id) {
                item.conversation_name_edit = value
                break
            }
        }

        this.props.handleCollectionConversationListAction(data)
    }

    handleConversationNameBlur(conversation_id) {
        this.props.handleConversationNameBlurAction(conversation_id)
    }
}

const mapStateToProps = (state) => {
    return {
        collection_conversation_list: state.get('collect').get('collection_conversation_list'),
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        handleCollectionConversationListAction(data) {
            dispatch(actionCreators.collectionConversationListAction(data))
        },
        handleConversationNameBlurAction(conversation_id) {
            dispatch(actionCreators.conversationNameBlurAction(conversation_id))
        },
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectItemInput))